/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'APP_THEME/_common/base/index.less';

import 'APP_THEME/_common/base/common';
import Header from 'APP_THEME/_common/base/header/index';
import LinkTagHelper from 'APP_THEME/_common/link_tag_helper/index';
import 'APP_THEME/_common/base/footer/index';
import 'assets/js/modules/popup/marketingLoginPopup';
import 'assets/js/common/cookiePolicy/index';

Header.init();
LinkTagHelper.addLink('//fonts.googleapis.com/css?family=Lato:300,400,700&display=swap');
LinkTagHelper.addLink('//netdna.bootstrapcdn.com/font-awesome/3.2.1/css/font-awesome.min.css');
